import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { tap } from 'rxjs';
import { RegisterGatewayResponse } from '../../models/hierarchy.model';
import { HierarchyService } from '../../services/hierarchy.service';

@Component({
  selector: 'app-register-gateway-modal',
  standalone: false,
  templateUrl: './register-gateway-modal.component.html',
  styleUrls: ['./register-gateway-modal.component.sass']
})
export class RegisterGatewayModalComponent {
  constructor(
    public dialogRef: MatDialogRef<RegisterGatewayModalComponent>,
    private hierarchyService: HierarchyService
  ) {}

  typeControl = new FormControl('', [Validators.required]);
  response: RegisterGatewayResponse | null = null;
  loading = false;

  onSubmit() {
    this.loading = true;

    this.hierarchyService
      .registerGateway(this.typeControl.value as string)
      .pipe(
        tap((res) => {
          this.response = res;
          this.loading = false;
        })
      )
      .subscribe();
  }
}
